const TRUNCATE_HEAD_CHARS = 15;
const TRUNCATE_TAIL_CHARS = 3;
const TRUNCATE_SEPARATOR = " ... ";
const TRUNCATE_DEFAULT_MAX_LENGTH =
  TRUNCATE_HEAD_CHARS + TRUNCATE_SEPARATOR.length + TRUNCATE_TAIL_CHARS;

export function capitalizeString(str: string) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function truncateMiddle(
  value: string,
  maxLength: number = TRUNCATE_DEFAULT_MAX_LENGTH,
): string {
  if (value.length <= maxLength) return value;
  const head = value.slice(0, TRUNCATE_HEAD_CHARS);
  const tail = value.slice(-TRUNCATE_TAIL_CHARS);
  return `${head}${TRUNCATE_SEPARATOR}${tail}`;
}
